import { z } from 'zod';
import { PARTNER_COCKPIT_MIN_PASSWORD_LENGTH, partnerCockpitNameFieldSchema } from './auth.js';
import { optionalPhoneNumberSchema } from './phoneNumber.js';
import { partnerCockpitMembershipStatusSchema } from './user.js';
export const teamMemberSchema = z.object({
    uuid: z.uuid(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    smsNotificationsEnabled: z.boolean(),
    status: partnerCockpitMembershipStatusSchema,
});
export const teamMembersSchema = z.array(teamMemberSchema);
// Ops-only: partners don't see when their teammates last logged in
export const opsTeamMemberSchema = teamMemberSchema.extend({
    lastLoginDate: z.iso.datetime().nullable(),
});
export const opsTeamMembersSchema = z.array(opsTeamMemberSchema);
export const inviteTeamMemberInputSchema = z.object({
    email: z.email(),
    firstName: partnerCockpitNameFieldSchema,
    lastName: partnerCockpitNameFieldSchema,
    phoneNumber: optionalPhoneNumberSchema,
});
export const editTeamMemberInputSchema = z.object({
    firstName: partnerCockpitNameFieldSchema,
    lastName: partnerCockpitNameFieldSchema,
    phoneNumber: optionalPhoneNumberSchema,
    smsNotificationsEnabled: z.boolean().optional(),
});
export const invitationInfoSchema = z.object({
    requiresPasswordSetup: z.boolean(),
    requiresTosAcceptance: z.boolean(),
});
export const acceptInvitationInputSchema = z.object({
    password: z.string().min(PARTNER_COCKPIT_MIN_PASSWORD_LENGTH).optional(),
    tosAccepted: z.boolean().optional(),
});
